<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="flex items-center justify-between">
                <div>
                    <vx-label :id="useForSendingLabelId" size="md">Use for Sending?</vx-label>
                    <div :id="useForSendingDescriptionId" class="text-sm text-slate-700">
                        Should this number be used to send messages?
                    </div>
                </div>
                <vx-toggle
                    v-model="useForSending"
                    :disabled="props.disabled"
                    :aria-labelledby="useForSendingLabelId"
                    :aria-describedby="useForSendingDescriptionId"
                    size="lg"
                ></vx-toggle>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import {
    VxExpandableCard,
    VxToggle,
    VxLabel,
} from '@voxie/frontend-components';
import { useId } from 'vue';

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
});

const useForSending = defineModel();

const useForSendingLabelId = useId();
const useForSendingDescriptionId = useId();
</script>
